import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import BlockRoundedIcon from '@mui/icons-material/BlockRounded';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { AvatarPartButton } from './avatarPartButton';
export const AvatarPartNoneButton = ({ onClick, isSelected }) => {
    return (_jsx(AvatarPartButton, { onClick: onClick, isSelected: isSelected, children: _jsx(IconWithLabelDisplay, { icon: _jsx(BlockRoundedIcon, {}), label: 'None' }) }));
};
